import React from 'react';
import randomstring from 'uuid/v4';

import Room from '@material-ui/icons/Room';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Done from '@material-ui/icons/Done';
import DoneAll from '@material-ui/icons/DoneAll';

import AnswerSee from './AnswerSee';

class Answers
    extends React.Component {

    state = {
        expand: false //this.props.nodo ? (this.props.nodo.pendientes || this.props.nodo.avisos) : false
    }

    static getDerivedStateFromProps(props, state) {
        if (props.nodo !== state.nodo) {
            state.nodo = props.nodo;
            return state;
        }
        return null;
    }

    handleExpand = (event) => {
        this.setState({ expand: !this.state.expand })
    }


    render() {
        const { expand, nodo } = this.state;

        console.log("Render node: ", nodo);

        if (!nodo) return <div />;
        return (
            <div className="flex_auto_column margin_top_8 margin_bottom_24">
                <div className="flex_auto_row align_center shadow_down_only hand"  >
                    {nodo.estado === 0 &&
                        <Done className="c_disabled" />
                    }
                    {nodo.estado === 1 &&
                        <Done className="c_bluish" />
                    }
                    {nodo.estado >= 2 &&
                        <DoneAll className="c_pea" />
                    }
                    <Room className={"margin_right_6 " + (nodo.avisos ? "c_pea" : "c_disabled")} />
                    <span className={"flex_full_row barlow_regular_small margin_right_24 " + (!nodo.pendientes ? "c_state" : "c_lipstick")}  >
                        {nodo.local}
                    </span>
                    {expand
                        ? <ExpandLess className="c_state" onClick={this.handleExpand} />
                        : <ExpandMore className="c_state" onClick={this.handleExpand} />
                    }
                </div>
                {(expand && nodo.mensajes) &&
                    nodo.mensajes.map((d) => {
                        return (
                            <AnswerSee {...this.props} key={randomstring()} info={d} />
                        )
                    })
                }
                {(expand && nodo.nodos) &&
                    nodo.nodos.map((n) => {
                        return (
                            <div key={randomstring()} className="flex_auto_column margin_left_18">
                                <Answers
                                    {...this.props} nodo={n} />
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default Answers
    ;


// WEBPACK FOOTER //
// ./src/components/complex/communications/Answers.js